module.exports = __webpack_public_path__ + "img/img_04@2x.492e87c7.png";